// import React, {
//   useEffect,
//   useState
// } from "react";

// import axios from "axios";

// import { API } from "../config";

// import "../../style/RectorAnaliticaSimulacro.css";

// export default function RectorAnaliticaSimulacro() {

//   const token =
//     localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* =====================================================
//      STATES
//   ===================================================== */

//   const [simulacros, setSimulacros] =
//     useState([]);

//   const [simulacroId, setSimulacroId] =
//     useState("");

//   const [loading, setLoading] =
//     useState(false);

//   const [analitica, setAnalitica] =
//     useState(null);

//   const [modoVista, setModoVista] =
//     useState("global");

//   /* =====================================================
//      GLOBAL
//   ===================================================== */

//   const [globalData, setGlobalData] =
//     useState(null);

//   /* =====================================================
//      GRUPO
//   ===================================================== */

//   const [grupoData, setGrupoData] =
//     useState(null);

//   const [grados, setGrados] =
//     useState([]);

//   const [grado, setGrado] =
//     useState("");

//   const [grupo, setGrupo] =
//     useState("");

//   const [sedeId, setSedeId] =
//     useState("");

//   /* =====================================================
//      ESTUDIANTE
//   ===================================================== */

//   const [estudiantes, setEstudiantes] =
//     useState([]);

//   const [matriculaId, setMatriculaId] =
//     useState("");

//   const [estudianteData, setEstudianteData] =
//     useState(null);

//   /* =====================================================
//      FETCH SIMULACROS
//   ===================================================== */

//   const fetchSimulacros = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/rector/simulacros`,
//         { headers }
//       );

//       const lista =
//         res.data.simulacros || [];

//       setSimulacros(lista);

//       if (lista.length > 0) {

//         setSimulacroId(
//           lista[0].id
//         );
//       }

//     } catch (err) {

//       console.error(
//         "❌ Error simulacros:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH GRADOS
//   ===================================================== */

//   const fetchGrados = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/rector/grados-once`,
//         { headers }
//       );

//       setGrados(
//         res.data.grados || []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error grados:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH ESTUDIANTES
//   ===================================================== */

//   const fetchEstudiantes = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/matriculas`,
//         { headers }
//       );

//       setEstudiantes(
//         res.data.matriculas || []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error estudiantes:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      ANALITICA NORMAL
//   ===================================================== */

//   const fetchAnalitica = async (
//     id
//   ) => {

//     try {

//       if (!id) return;

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/simulacros/rector/analitica/${id}`,
//         { headers }
//       );

//       setAnalitica(
//         res.data
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error analítica:",
//         err.response?.data || err.message
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      ANALITICA GLOBAL
//   ===================================================== */

//   const fetchGlobal = async () => {

//     try {

//       if (!simulacroId) return;

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/simulacros/rector/analitica/global/${simulacroId}`,
//         { headers }
//       );

//       setGlobalData(
//         res.data
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error global:",
//         err.response?.data || err.message
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      ANALITICA GRUPO
//   ===================================================== */

//   const fetchGrupo = async () => {

//     try {

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/simulacros/rector/analitica/grupo`,
//         {
//           headers,

//           params: {
//             sede_id: sedeId,
//             grado,
//             grupo,
//             simulacro_id:
//               simulacroId
//           }
//         }
//       );

//       setGrupoData(
//         res.data
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error grupo:",
//         err.response?.data || err.message
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      ANALITICA ESTUDIANTE
//   ===================================================== */

//   const fetchEstudiante = async () => {

//     try {

//       if (!matriculaId) {

//         return alert(
//           "Seleccione estudiante"
//         );
//       }

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/simulacros/rector/analitica/estudiante/${matriculaId}`,
//         { headers }
//       );

//       setEstudianteData(
//         res.data
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error estudiante:",
//         err.response?.data || err.message
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      INIT
//   ===================================================== */

//   useEffect(() => {

//     fetchSimulacros();
//     fetchGrados();
//     fetchEstudiantes();

//   }, []);

//   /* =====================================================
//      CAMBIO SIMULACRO
//   ===================================================== */

//   useEffect(() => {

//     if (
//       simulacroId &&
//       modoVista === "normal"
//     ) {

//       fetchAnalitica(
//         simulacroId
//       );
//     }

//     if (
//       simulacroId &&
//       modoVista === "global"
//     ) {

//       fetchGlobal();
//     }

//   }, [
//     simulacroId,
//     modoVista
//   ]);

//   /* =====================================================
//      DATOS
//   ===================================================== */

//   const estadisticas =
//     analitica?.estadisticas || {};

//   const pendientes =
//     analitica?.estudiantes_pendientes || [];

//   const grupos =
//     analitica?.promedios_por_grupo || [];

//   const sedes =
//     analitica?.promedios_por_sede || [];

//   const materias =
//     analitica?.materias_debiles || [];

//   const preguntas =
//     analitica?.preguntas_mas_falladas || [];

//   /* =====================================================
//      RENDER
//   ===================================================== */

//   return (

//     <div className="rector-analitica-container">

//       {/* ========================================= */}
//       {/* HEADER */}
//       {/* ========================================= */}

//       <div className="analitica-header">

//         <div>

//           <h2>
//             📈 Analítica de Simulacros
//           </h2>

//         </div>

//         <select
//           value={modoVista}
//           onChange={(e) =>
//             setModoVista(
//               e.target.value
//             )
//           }
//         >

//           <option value="normal">
//             Analítica Simulacro
//           </option>

//           <option value="global">
//             Global
//           </option>

//           <option value="grupo">
//             Por Grupo
//           </option>

//           <option value="estudiante">
//             Individual Estudiante
//           </option>

//         </select>

//       </div>

//       {/* ========================================= */}
//       {/* NORMAL */}
//       {/* ========================================= */}

//       {
//         modoVista === "normal" && (

//           <>

//             <select
//               value={simulacroId}
//               onChange={(e) =>
//                 setSimulacroId(
//                   e.target.value
//                 )
//               }
//             >

//               {
//                 simulacros.map((s) => (

//                   <option
//                     key={s.id}
//                     value={s.id}
//                   >
//                     {s.titulo}
//                   </option>
//                 ))
//               }

//             </select>

//             <div className="analitica-grid">

//               <div className="analitica-card">

//                 <h3>
//                   👥 Total estudiantes
//                 </h3>

//                 <p>
//                   {
//                     estadisticas.total_estudiantes || 0
//                   }
//                 </p>

//               </div>

//               <div className="analitica-card">

//                 <h3>
//                   ✅ Presentaron
//                 </h3>

//                 <p>
//                   {
//                     estadisticas.presentaron || 0
//                   }
//                 </p>

//               </div>

//               <div className="analitica-card">

//                 <h3>
//                   🚫 Pendientes
//                 </h3>

//                 <p>
//                   {
//                     estadisticas.pendientes || 0
//                   }
//                 </p>

//               </div>

//               <div className="analitica-card">

//                 <h3>
//                   📊 Promedio
//                 </h3>

//                 <p>
//                   {
//                     estadisticas.promedio_general || 0
//                   }%
//                 </p>

//               </div>

//             </div>

//             {/* PENDIENTES */}

//             <div className="analitica-section">

//               <h3>
//                 🚫 No presentaron
//               </h3>

//               {
//                 pendientes.map((e) => (

//                   <div
//                     key={e.id}
//                     className="pregunta-card"
//                   >

//                     👤
//                     {" "}
//                     {
//                       e.nombres_estudiante
//                     }
//                     {" "}
//                     {
//                       e.apellidos_estudiante
//                     }

//                     {" - "}

//                     {
//                       e.grado
//                     }

//                     {
//                       e.grupo
//                     }

//                   </div>
//                 ))
//               }

//             </div>

//             {/* GRUPOS */}

//             <div className="analitica-section">

//               <h3>
//                 🏫 Promedios grupos
//               </h3>

//               {
//                 grupos.map((g, i) => (

//                   <div
//                     key={i}
//                     className="pregunta-card"
//                   >

//                     📘
//                     {" "}
//                     {g.grado}
//                     {" "}
//                     {g.grupo}

//                     {" → "}

//                     {g.promedio}%

//                   </div>
//                 ))
//               }

//             </div>

//             {/* SEDES */}

//             <div className="analitica-section">

//               <h3>
//                 🏢 Promedios sedes
//               </h3>

//               {
//                 sedes.map((s, i) => (

//                   <div
//                     key={i}
//                     className="pregunta-card"
//                   >

//                     🏢
//                     {" "}
//                     {s.sede}

//                     {" → "}

//                     {s.promedio}%

//                   </div>
//                 ))
//               }

//             </div>

//             {/* MATERIAS */}

//             <div className="analitica-section">

//               <h3>
//                 📉 Materias débiles
//               </h3>

//               {
//                 materias.map((m, i) => (

//                   <div
//                     key={i}
//                     className="pregunta-card"
//                   >

//                     📚
//                     {" "}
//                     {m.materia}

//                     {" → "}

//                     {m.promedio}%

//                   </div>
//                 ))
//               }

//             </div>

//             {/* PREGUNTAS */}

//             <div className="analitica-section">

//               <h3>
//                 ❌ Preguntas más falladas
//               </h3>

//               {
//                 preguntas.map((p) => (

//                   <div
//                     key={p.id}
//                     className="pregunta-card"
//                   >

//                     <div>
//                       ❓
//                       {" "}
//                       {p.enunciado}
//                     </div>

//                     <div>
//                       📉
//                       {" "}
//                       {p.porcentaje_error}%
//                     </div>

//                   </div>
//                 ))
//               }

//             </div>

//           </>
//         )
//       }

//       {/* ========================================= */}
//       {/* GLOBAL */}
//       {/* ========================================= */}

//       {
//         modoVista === "global" && (

//           <>

//             <select
//               value={simulacroId}
//               onChange={(e) =>
//                 setSimulacroId(
//                   e.target.value
//                 )
//               }
//             >

//               {
//                 simulacros.map((s) => (

//                   <option
//                     key={s.id}
//                     value={s.id}
//                   >
//                     {s.titulo}
//                   </option>
//                 ))
//               }

//             </select>

//             <button
//               onClick={fetchGlobal}
//             >
//               Ver Global
//             </button>

//             {
//               globalData?.ok && (

//                 <div className="analitica-section">

//                   <h3>
//                     🌎 Analítica Global
//                   </h3>

//                   <div className="pregunta-card">

//                     <div>
//                       👥 Total:
//                       {" "}
//                       {
//                         globalData.total_estudiantes
//                       }
//                     </div>

//                     <div>
//                       📊 Promedio:
//                       {" "}
//                       {
//                         globalData.promedio_general
//                       }%
//                     </div>

//                     <div>
//                       ✅ Presentaron:
//                       {" "}
//                       {
//                         globalData.presentaron
//                       }
//                     </div>

//                   </div>

//                 </div>
//               )
//             }

//           </>
//         )
//       }

//       {/* ========================================= */}
//       {/* GRUPO */}
//       {/* ========================================= */}

//       {
//         modoVista === "grupo" && (

//           <>

//             <div className="analitica-grid">

//               <select
//                 value={sedeId}
//                 onChange={(e) =>
//                   setSedeId(
//                     e.target.value
//                   )
//                 }
//               >

//                 <option value="">
//                   Sede
//                 </option>

//                 {
//                   grados.map((g, i) => (

//                     <option
//                       key={i}
//                       value={g.sede_id}
//                     >
//                       {g.sede}
//                     </option>
//                   ))
//                 }

//               </select>

//               <select
//                 value={grado}
//                 onChange={(e) =>
//                   setGrado(
//                     e.target.value
//                   )
//                 }
//               >

//                 <option value="">
//                   Grado
//                 </option>

//                 {
//                   [...new Set(
//                     grados.map(
//                       g => g.grado
//                     )
//                   )].map((g, i) => (

//                     <option
//                       key={i}
//                       value={g}
//                     >
//                       {g}
//                     </option>
//                   ))
//                 }

//               </select>

//               <select
//                 value={grupo}
//                 onChange={(e) =>
//                   setGrupo(
//                     e.target.value
//                   )
//                 }
//               >

//                 <option value="">
//                   Grupo
//                 </option>

//                 {
//                   [...new Set(
//                     grados.map(
//                       g => g.grupo
//                     )
//                   )].map((g, i) => (

//                     <option
//                       key={i}
//                       value={g}
//                     >
//                       {g}
//                     </option>
//                   ))
//                 }

//               </select>

//               <select
//                 value={simulacroId}
//                 onChange={(e) =>
//                   setSimulacroId(
//                     e.target.value
//                   )
//                 }
//               >

//                 {
//                   simulacros.map((s) => (

//                     <option
//                       key={s.id}
//                       value={s.id}
//                     >
//                       {s.titulo}
//                     </option>
//                   ))
//                 }

//               </select>

//             </div>

//             <button
//               onClick={fetchGrupo}
//             >
//               🔍 Ver Grupo
//             </button>

//             {
//               grupoData?.ok && (

//                 <div className="analitica-section">

//                   <h3>
//                     🏫 Resultado Grupo
//                   </h3>

//                   {
//                     grupoData.estudiantes?.map((e) => (

//                       <div
//                         key={e.estudiante_id}
//                         className="pregunta-card"
//                       >

//                         👤
//                         {" "}
//                         {e.estudiante}

//                         {" → "}

//                         📊
//                         {" "}
//                         {e.puntaje}%

//                       </div>
//                     ))
//                   }

//                 </div>
//               )
//             }

//           </>
//         )
//       }

//       {/* ========================================= */}
//       {/* ESTUDIANTE */}
//       {/* ========================================= */}

//       {
//         modoVista === "estudiante" && (

//           <>

//             <div
//               className="analitica-grid"
//             >

//               <select
//                 value={matriculaId}
//                 onChange={(e) =>
//                   setMatriculaId(
//                     e.target.value
//                   )
//                 }
//               >

//                 <option value="">
//                   Seleccione estudiante
//                 </option>

//                 {
//                   estudiantes.map((e) => (

//                     <option
//                       key={e.id}
//                       value={e.id}
//                     >
//                       {
//                         e.nombres_estudiante
//                       }

//                       {" "}

//                       {
//                         e.apellidos_estudiante
//                       }

//                       {" - "}

//                       {
//                         e.grado
//                       }

//                       {
//                         e.grupo
//                       }

//                     </option>
//                   ))
//                 }

//               </select>

//               <button
//                 onClick={
//                   fetchEstudiante
//                 }
//               >
//                 🔍 Ver estudiante
//               </button>

//             </div>

//             {
//               estudianteData?.ok && (

//                 <>

//                   <div className="analitica-grid">

//                     <div className="analitica-card">

//                       <h3>
//                         👤 Estudiante
//                       </h3>

//                       <p>
//                         {
//                           estudianteData
//                             .estudiante
//                             ?.nombres_estudiante
//                         }

//                         {" "}

//                         {
//                           estudianteData
//                             .estudiante
//                             ?.apellidos_estudiante
//                         }
//                       </p>

//                     </div>

//                     <div className="analitica-card">

//                       <h3>
//                         📊 Promedio
//                       </h3>

//                       <p>
//                         {
//                           estudianteData
//                             .promedio_general
//                         }%
//                       </p>

//                     </div>

//                   </div>

//                   {/* EVOLUCION */}

//                   <div className="analitica-section">

//                     <h3>
//                       📈 Evolución
//                     </h3>

//                     {
//                       estudianteData
//                         .evolucion
//                         ?.map((e, i) => (

//                           <div
//                             key={i}
//                             className="pregunta-card"
//                           >

//                             📘
//                             {" "}
//                             {
//                               e.simulacro
//                             }

//                             {" → "}

//                             📊
//                             {" "}
//                             {
//                               e.puntaje
//                             }%

//                           </div>
//                         ))
//                     }

//                   </div>

//                   {/* MATERIAS FUERTES */}

//                   <div className="analitica-section">

//                     <h3>
//                       💪 Materias fuertes
//                     </h3>

//                     {
//                       estudianteData
//                         .materias_fuertes
//                         ?.map((m, i) => (

//                           <div
//                             key={i}
//                             className="pregunta-card"
//                           >

//                             📚
//                             {" "}
//                             {
//                               m.materia
//                             }

//                             {" → "}

//                             {
//                               m.promedio
//                             }%

//                           </div>
//                         ))
//                     }

//                   </div>

//                   {/* MATERIAS DEBILES */}

//                   <div className="analitica-section">

//                     <h3>
//                       📉 Materias débiles
//                     </h3>

//                     {
//                       estudianteData
//                         .materias_debiles
//                         ?.map((m, i) => (

//                           <div
//                             key={i}
//                             className="pregunta-card"
//                           >

//                             📚
//                             {" "}
//                             {
//                               m.materia
//                             }

//                             {" → "}

//                             {
//                               m.promedio
//                             }%

//                           </div>
//                         ))
//                     }

//                   </div>

//                 </>
//               )
//             }

//           </>
//         )
//       }

//       {/* ========================================= */}
//       {/* LOADING */}
//       {/* ========================================= */}

//       {
//         loading && (

//           <div className="loading-box">
//             ⏳ Cargando...
//           </div>
//         )
//       }

//     </div>
//   );
// }


//


import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import axios from "axios";

import { API } from "../config";

import "../../style/RectorAnaliticaSimulacro.css";

export default function RectorAnaliticaSimulacro() {

  const token =
    localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     STATES
  ===================================================== */

  const [simulacros, setSimulacros] =
    useState([]);

  const [simulacroId, setSimulacroId] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [analitica, setAnalitica] =
    useState(null);

  const [modoVista, setModoVista] =
    useState("global");

  /* =====================================================
     GLOBAL
  ===================================================== */

  const [globalData, setGlobalData] =
    useState(null);

  /* =====================================================
     GRUPO
  ===================================================== */

  const [grupoData, setGrupoData] =
    useState(null);

  const [grados, setGrados] =
    useState([]);

  const [grado, setGrado] =
    useState("");

  const [grupo, setGrupo] =
    useState("");

  const [sedeId, setSedeId] =
    useState("");

  /* =====================================================
     ESTUDIANTE
  ===================================================== */

  const [estudiantes, setEstudiantes] =
    useState([]);

  const [matriculaId, setMatriculaId] =
    useState("");

  const [estudianteData, setEstudianteData] =
    useState(null);

  /* =====================================================
     RANKING
  ===================================================== */

  const [rankingData, setRankingData] =
    useState(null);

  /* =====================================================
     FETCH SIMULACROS
  ===================================================== */

  const fetchSimulacros = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/simulacros`,
        { headers }
      );

      const lista =
        res.data.simulacros || [];

      setSimulacros(lista);

      if (lista.length > 0) {

        setSimulacroId(
          lista[0].id
        );
      }

    } catch (err) {

      console.error(
        "❌ Error simulacros:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH GRADOS
  ===================================================== */

  const fetchGrados = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/grados-once`,
        { headers }
      );

      setGrados(
        res.data.grados || []
      );

    } catch (err) {

      console.error(
        "❌ Error grados:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH ESTUDIANTES
  ===================================================== */

  const fetchEstudiantes = async () => {

    try {

      const res = await axios.get(
        `${API}/matriculas`,
        { headers }
      );

      setEstudiantes(
        res.data.matriculas || []
      );

    } catch (err) {

      console.error(
        "❌ Error estudiantes:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     ANALITICA NORMAL
  ===================================================== */

  const fetchAnalitica = async (
    id
  ) => {

    try {

      if (!id) return;

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/rector/analitica/${id}`,
        { headers }
      );

      setAnalitica(
        res.data
      );

    } catch (err) {

      console.error(
        "❌ Error analítica:",
        err.response?.data || err.message
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     ANALITICA GLOBAL
  ===================================================== */

  const fetchGlobal = async () => {

    try {

      if (!simulacroId) return;

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/rector/analitica/global/${simulacroId}`,
        { headers }
      );

      setGlobalData(
        res.data
      );

    } catch (err) {

      console.error(
        "❌ Error global:",
        err.response?.data || err.message
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     ANALITICA GRUPO
  ===================================================== */

  const fetchGrupo = async () => {

    try {

      if (
        !sedeId ||
        !grado ||
        !grupo ||
        !simulacroId
      ) {

        return alert(
          "Seleccione sede, grado, grupo y simulacro"
        );
      }

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/rector/analitica/grupo`,
        {
          headers,

          params: {
            sede_id: sedeId,
            grado,
            grupo,
            simulacro_id:
              simulacroId
          }
        }
      );

      setGrupoData(
        res.data
      );

    } catch (err) {

      console.error(
        "❌ Error grupo:",
        err.response?.data || err.message
      );

      alert(
        err.response?.data?.message ||
        "Error obteniendo grupo"
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     ANALITICA ESTUDIANTE
  ===================================================== */

  const fetchEstudiante = async () => {

    try {

      if (!matriculaId) {

        return alert(
          "Seleccione estudiante"
        );
      }

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/rector/analitica/estudiante/${matriculaId}`,
        { headers }
      );

      setEstudianteData(
        res.data
      );

    } catch (err) {

      console.error(
        "❌ Error estudiante:",
        err.response?.data || err.message
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     RANKING
  ===================================================== */

  const fetchRanking = async () => {

    try {

      if (!simulacroId) {

        return alert(
          "Seleccione simulacro"
        );
      }

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/rector/ranking/${simulacroId}`,
        { headers }
      );

      setRankingData(
        res.data
      );

    } catch (err) {

      console.error(
        "❌ Error ranking:",
        err.response?.data || err.message
      );

      alert(
        err.response?.data?.message ||
        "Error obteniendo ranking"
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     INIT
  ===================================================== */

  useEffect(() => {

    fetchSimulacros();
    fetchGrados();
    fetchEstudiantes();

  }, []);

  /* =====================================================
     CAMBIO SIMULACRO
  ===================================================== */

  useEffect(() => {

    if (
      simulacroId &&
      modoVista === "normal"
    ) {

      fetchAnalitica(
        simulacroId
      );
    }

    if (
      simulacroId &&
      modoVista === "global"
    ) {

      fetchGlobal();
    }

    if (
      simulacroId &&
      modoVista === "ranking"
    ) {

      fetchRanking();
    }

  }, [
    simulacroId,
    modoVista
  ]);

  /* =====================================================
     DATOS
  ===================================================== */

  const estadisticas =
    analitica?.estadisticas || {};

  const pendientes =
    analitica?.estudiantes_pendientes || [];

  const grupos =
    analitica?.promedios_por_grupo || [];

  const sedes =
    analitica?.promedios_por_sede || [];

  const materias =
    analitica?.materias_debiles || [];

  const preguntas =
    analitica?.preguntas_mas_falladas || [];

  /* =====================================================
     FILTROS
  ===================================================== */

  const sedesUnicas =
    useMemo(() => {

      return [
        ...new Map(
          grados.map((g) => [
            g.sede_id,
            {
              sede_id: g.sede_id,
              sede: g.sede
            }
          ])
        ).values()
      ];

    }, [grados]);

  const gradosUnicos =
    useMemo(() => {

      return [
        ...new Set(
          grados.map(
            (g) => g.grado
          )
        )
      ];

    }, [grados]);

  const gruposUnicos =
    useMemo(() => {

      return [
        ...new Set(
          grados.map(
            (g) => g.grupo
          )
        )
      ];

    }, [grados]);

  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="rector-analitica-container">

      {/* ========================================= */}
      {/* HEADER */}
      {/* ========================================= */}

      <div className="analitica-header">

        <div>

          <h2>
            📈 Analítica de Simulacros
          </h2>

        </div>

        <select
          value={modoVista}
          onChange={(e) =>
            setModoVista(
              e.target.value
            )
          }
        >

          <option value="normal">
            Analítica Simulacro
          </option>

          <option value="global">
            Global
          </option>

          <option value="grupo">
            Por Grupo
          </option>

          <option value="estudiante">
            Individual Estudiante
          </option>

          <option value="ranking">
            🏆 Ranking General
          </option>

        </select>

      </div>

      {/* ========================================= */}
      {/* NORMAL */}
      {/* ========================================= */}

      {
        modoVista === "normal" && (

          <>

            <select
              value={simulacroId}
              onChange={(e) =>
                setSimulacroId(
                  e.target.value
                )
              }
            >

              {
                simulacros.map((s) => (

                  <option
                    key={s.id}
                    value={s.id}
                  >
                    {s.titulo}
                  </option>
                ))
              }

            </select>

            <div className="analitica-grid">

              <div className="analitica-card">

                <h3>
                  👥 Total estudiantes
                </h3>

                <p>
                  {
                    estadisticas.total_estudiantes || 0
                  }
                </p>

              </div>

              <div className="analitica-card">

                <h3>
                  ✅ Presentaron
                </h3>

                <p>
                  {
                    estadisticas.presentaron || 0
                  }
                </p>

              </div>

              <div className="analitica-card">

                <h3>
                  🚫 Pendientes
                </h3>

                <p>
                  {
                    estadisticas.pendientes || 0
                  }
                </p>

              </div>

              <div className="analitica-card">

                <h3>
                  📊 Promedio
                </h3>

                <p>
                  {
                    estadisticas.promedio_general || 0
                  }%
                </p>

              </div>

            </div>

            <div className="analitica-section">

              <h3>
                🚫 No presentaron
              </h3>

              {
                pendientes.map((e) => (

                  <div
                    key={e.id}
                    className="pregunta-card"
                  >

                    👤
                    {" "}
                    {
                      e.nombres_estudiante
                    }
                    {" "}
                    {
                      e.apellidos_estudiante
                    }

                    {" - "}

                    {
                      e.grado
                    }

                    {
                      e.grupo
                    }

                  </div>
                ))
              }

            </div>

            <div className="analitica-section">

              <h3>
                🏫 Promedios grupos
              </h3>

              {
                grupos.map((g, i) => (

                  <div
                    key={i}
                    className="pregunta-card"
                  >

                    📘
                    {" "}
                    {g.grado}
                    {" "}
                    {g.grupo}

                    {" → "}

                    {g.promedio}%

                  </div>
                ))
              }

            </div>

            <div className="analitica-section">

              <h3>
                🏢 Promedios sedes
              </h3>

              {
                sedes.map((s, i) => (

                  <div
                    key={i}
                    className="pregunta-card"
                  >

                    🏢
                    {" "}
                    {s.sede}

                    {" → "}

                    {s.promedio}%

                  </div>
                ))
              }

            </div>

            <div className="analitica-section">

              <h3>
                📉 Materias débiles
              </h3>

              {
                materias.map((m, i) => (

                  <div
                    key={i}
                    className="pregunta-card"
                  >

                    📚
                    {" "}
                    {m.materia}

                    {" → "}

                    {m.promedio}%

                  </div>
                ))
              }

            </div>

            <div className="analitica-section">

              <h3>
                ❌ Preguntas más falladas
              </h3>

              {
                preguntas.map((p) => (

                  <div
                    key={p.id}
                    className="pregunta-card"
                  >

                    <div>
                      ❓
                      {" "}
                      {p.enunciado}
                    </div>

                    <div>
                      📉
                      {" "}
                      {p.porcentaje_error}%
                    </div>

                  </div>
                ))
              }

            </div>

          </>
        )
      }

      {/* ========================================= */}
      {/* GLOBAL */}
      {/* ========================================= */}

      {
        modoVista === "global" && (

          <>

            <select
              value={simulacroId}
              onChange={(e) =>
                setSimulacroId(
                  e.target.value
                )
              }
            >

              {
                simulacros.map((s) => (

                  <option
                    key={s.id}
                    value={s.id}
                  >
                    {s.titulo}
                  </option>
                ))
              }

            </select>

            <button
              onClick={fetchGlobal}
            >
              🌎 Ver Global
            </button>

            {
              globalData?.ok && (

                <div className="analitica-section">

                  <h3>
                    🌎 Analítica Global
                  </h3>

                  <div className="pregunta-card">

                    <div>
                      👥 Total:
                      {" "}
                      {
                        globalData.total_estudiantes
                      }
                    </div>

                    <div>
                      📊 Promedio:
                      {" "}
                      {
                        globalData.promedio_general
                      }%
                    </div>

                    <div>
                      ✅ Presentaron:
                      {" "}
                      {
                        globalData.presentaron
                      }
                    </div>

                  </div>

                </div>
              )
            }

          </>
        )
      }

      {/* ========================================= */}
      {/* GRUPO */}
      {/* ========================================= */}

      {
        modoVista === "grupo" && (

          <>

            <div className="analitica-grid">

              <select
                value={sedeId}
                onChange={(e) =>
                  setSedeId(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Sede
                </option>

                {
                  sedesUnicas.map((s) => (

                    <option
                      key={s.sede_id}
                      value={s.sede_id}
                    >
                      {s.sede}
                    </option>
                  ))
                }

              </select>

              <select
                value={grado}
                onChange={(e) =>
                  setGrado(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Grado
                </option>

                {
                  gradosUnicos.map((g, i) => (

                    <option
                      key={i}
                      value={g}
                    >
                      {g}
                    </option>
                  ))
                }

              </select>

              <select
                value={grupo}
                onChange={(e) =>
                  setGrupo(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Grupo
                </option>

                {
                  gruposUnicos.map((g, i) => (

                    <option
                      key={i}
                      value={g}
                    >
                      {g}
                    </option>
                  ))
                }

              </select>

              <select
                value={simulacroId}
                onChange={(e) =>
                  setSimulacroId(
                    e.target.value
                  )
                }
              >

                {
                  simulacros.map((s) => (

                    <option
                      key={s.id}
                      value={s.id}
                    >
                      {s.titulo}
                    </option>
                  ))
                }

              </select>

            </div>

            <button
              onClick={fetchGrupo}
            >
              🔍 Ver Grupo
            </button>

            {
              grupoData?.ok && (

                <div className="analitica-section">

                  <h3>
                    🏫 Resultado Grupo
                  </h3>

                  <div className="analitica-grid">

                    <div className="analitica-card">
                      <h3>👥 Estudiantes</h3>
                      <p>
                        {
                          grupoData.total_estudiantes || 0
                        }
                      </p>
                    </div>

                    <div className="analitica-card">
                      <h3>📊 Promedio</h3>
                      <p>
                        {
                          grupoData.promedio_general || 0
                        }%
                      </p>
                    </div>

                  </div>

                  {
                    grupoData.estudiantes?.map((e) => (

                      <div
                        key={e.estudiante_id}
                        className="pregunta-card"
                      >

                        👤
                        {" "}
                        {e.estudiante}

                        {" → "}

                        📊
                        {" "}
                        {e.puntaje}%

                      </div>
                    ))
                  }

                </div>
              )
            }

          </>
        )
      }

      {/* ========================================= */}
      {/* ESTUDIANTE */}
      {/* ========================================= */}

      {
        modoVista === "estudiante" && (

          <>

            <div
              className="analitica-grid"
            >

              <select
                value={matriculaId}
                onChange={(e) =>
                  setMatriculaId(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Seleccione estudiante
                </option>

                {
                  estudiantes.map((e) => (

                    <option
                      key={e.id}
                      value={e.id}
                    >
                      {
                        e.nombres_estudiante
                      }

                      {" "}

                      {
                        e.apellidos_estudiante
                      }

                      {" - "}

                      {
                        e.grado
                      }

                      {
                        e.grupo
                      }

                    </option>
                  ))
                }

              </select>

              <button
                onClick={
                  fetchEstudiante
                }
              >
                🔍 Ver estudiante
              </button>

            </div>

            {
              estudianteData?.ok && (

                <>

                  <div className="analitica-grid">

                    <div className="analitica-card">

                      <h3>
                        👤 Estudiante
                      </h3>

                      <p>
                        {
                          estudianteData
                            .estudiante
                            ?.nombres_estudiante
                        }

                        {" "}

                        {
                          estudianteData
                            .estudiante
                            ?.apellidos_estudiante
                        }
                      </p>

                    </div>

                    <div className="analitica-card">

                      <h3>
                        📊 Promedio
                      </h3>

                      <p>
                        {
                          estudianteData
                            .promedio_general
                        }%
                      </p>

                    </div>

                  </div>

                  <div className="analitica-section">

                    <h3>
                      📈 Evolución
                    </h3>

                    {
                      estudianteData
                        .evolucion
                        ?.map((e, i) => (

                          <div
                            key={i}
                            className="pregunta-card"
                          >

                            📘
                            {" "}
                            {
                              e.simulacro
                            }

                            {" → "}

                            📊
                            {" "}
                            {
                              e.puntaje
                            }%

                          </div>
                        ))
                    }

                  </div>

                  <div className="analitica-section">

                    <h3>
                      💪 Materias fuertes
                    </h3>

                    {
                      estudianteData
                        .materias_fuertes
                        ?.map((m, i) => (

                          <div
                            key={i}
                            className="pregunta-card"
                          >

                            📚
                            {" "}
                            {
                              m.materia
                            }

                            {" → "}

                            {
                              m.promedio
                            }%

                          </div>
                        ))
                    }

                  </div>

                  <div className="analitica-section">

                    <h3>
                      📉 Materias débiles
                    </h3>

                    {
                      estudianteData
                        .materias_debiles
                        ?.map((m, i) => (

                          <div
                            key={i}
                            className="pregunta-card"
                          >

                            📚
                            {" "}
                            {
                              m.materia
                            }

                            {" → "}

                            {
                              m.promedio
                            }%

                          </div>
                        ))
                    }

                  </div>

                </>
              )
            }

          </>
        )
      }

      {/* ========================================= */}
      {/* RANKING */}
      {/* ========================================= */}

      {
        modoVista === "ranking" && (

          <>

            <div className="analitica-grid">

              <select
                value={simulacroId}
                onChange={(e) =>
                  setSimulacroId(
                    e.target.value
                  )
                }
              >

                {
                  simulacros.map((s) => (

                    <option
                      key={s.id}
                      value={s.id}
                    >
                      {s.titulo}
                    </option>
                  ))
                }

              </select>

              <button
                onClick={fetchRanking}
              >
                🏆 Ver Ranking
              </button>

            </div>

            {
              rankingData?.ok && (

                <>

                  {/* TOP GENERAL */}

                  <div className="analitica-section">

                    <h3>
                      🥇 Top 10 General
                    </h3>

                    {
                      rankingData
                        .top_general
                        ?.map((e, i) => (

                          <div
                            key={i}
                            className="pregunta-card"
                          >

                            #{i + 1}

                            {" - "}

                            👤
                            {" "}
                            {e.estudiante}

                            {" - "}

                            📘
                            {" "}
                            {e.grado}
                            {e.grupo}

                            {" - "}

                            📊
                            {" "}
                            {e.puntaje}%

                          </div>
                        ))
                    }

                  </div>

                  {/* TOP POR GRUPO */}

                  <div className="analitica-section">

                    <h3>
                      🏫 Top por Grupo
                    </h3>

                    {
                      rankingData
                        .top_por_grupo
                        ?.map((g, i) => (

                          <div
                            key={i}
                            className="pregunta-card"
                          >

                            📘
                            {" "}
                            {g.grado}
                            {g.grupo}

                            {" → "}

                            👤
                            {" "}
                            {g.estudiante}

                            {" → "}

                            📊
                            {" "}
                            {g.puntaje}%

                          </div>
                        ))
                    }

                  </div>

                  {/* MEJOR PUNTAJE */}

                  <div className="analitica-section">

                    <h3>
                      🏆 Mejor Puntaje
                    </h3>

                    <div className="pregunta-card">

                      👤
                      {" "}
                      {
                        rankingData
                          .mejor_puntaje
                          ?.estudiante
                      }

                      {" - "}

                      📊
                      {" "}
                      {
                        rankingData
                          .mejor_puntaje
                          ?.puntaje
                      }%

                    </div>

                  </div>

                  {/* PROMEDIO */}

                  <div className="analitica-section">

                    <h3>
                      📊 Promedio General
                    </h3>

                    <div className="pregunta-card">

                      📈
                      {" "}
                      {
                        rankingData
                          .promedio_general || 0
                      }%

                    </div>

                  </div>

                </>
              )
            }

          </>
        )
      }

      {/* ========================================= */}
      {/* LOADING */}
      {/* ========================================= */}

      {
        loading && (

          <div className="loading-box">
            ⏳ Cargando...
          </div>
        )
      }

    </div>
  );
}